export enum TransactionTypeEnum {
  ALL = "",
  DEPOSIT = "DEPOSIT",
  WITHDRAW = "WITHDRAW",
  RAKEBACK = "RAKEBACK",
  DEX = "DEX",
}

export const TransactionTypes = [
  TransactionTypeEnum.DEPOSIT,
  TransactionTypeEnum.WITHDRAW,
  TransactionTypeEnum.RAKEBACK,
  TransactionTypeEnum.DEX,
];

export type PaymentMethodType = {
  id: number;
  name: string;
};

export enum PaymentMethodTypeEnum {
  ALL = 0,
  CRYPTO,
  BANK_TRANSFER,
  CARD_PAYMENT,
}

export const PaymentMethodTypes: PaymentMethodType[] = [
  { id: PaymentMethodTypeEnum.CRYPTO, name: "CRYPTO" },
  { id: PaymentMethodTypeEnum.BANK_TRANSFER, name: "BANK_TRANSFER" },
  { id: PaymentMethodTypeEnum.CARD_PAYMENT, name: "CARD_PAYMENT" },
];
